import { useReactiveVar } from '@apollo/client'
import { useEffect, useState } from 'react'

import { ListWorkersForAutocompleteQuery } from '@/types/graphql'

import useDebouncedValue from '@/hooks/useDebouncedValue'

import AutocompleteField from '@/form/AutocompleteField'

import { currentAgencyVar } from '@/util/apollo/cache'

import { useListWorkersForAutocompleteLazyQuery } from '@/graphql'

export type WorkerItem = ListWorkersForAutocompleteQuery['agency']['workers']['items'][0]

type Props = {
  fieldId: string
  label: string
}

const WorkerAutocompleteField = ({ fieldId, label }: Props) => {
  const currentAgency = useReactiveVar(currentAgencyVar)
  const [fetch, { data, loading }] = useListWorkersForAutocompleteLazyQuery()

  const [query, setQuery] = useState('')
  const debouncedQuery = useDebouncedValue(query, 300)

  useEffect(() => {
    fetch({
      variables: {
        agencyId: currentAgency!.id,
        filters:
          debouncedQuery.length > 0
            ? { query: { value: debouncedQuery } }
            : null,
      },
    })
  }, [debouncedQuery])

  return (
    <AutocompleteField<WorkerItem>
      autoFocus
      required
      disabled={loading}
      fieldId={fieldId}
      items={data ? data.agency.workers.items : []}
      itemToKey={(item) => item.id}
      itemToString={(item) =>
        item ? `${item.user.firstName} ${item.user.lastName}` : ''
      }
      label={label}
      placeholder="Select worker..."
      onInputValueChange={({ inputValue }) => setQuery(inputValue ?? '')}
    />
  )
}

export default WorkerAutocompleteField
